/* Facets Drawer — open/close + auto-submit sort */
class FacetsDrawer extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-facets-close]').forEach((el) =>
      el.addEventListener('click', () => this.close())
    );
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.classList.contains('is-open')) this.close();
    });
  }
  open() {
    this.classList.add('is-open');
    this.setAttribute('aria-hidden', 'false');
    document.body.classList.add('facets-drawer-open');
  }
  close() {
    this.classList.remove('is-open');
    this.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('facets-drawer-open');
  }
}
if (!customElements.get('facets-drawer')) customElements.define('facets-drawer', FacetsDrawer);

document.addEventListener('click', (e) => {
  const opener = e.target.closest('[data-facets-open]');
  if (!opener) return;
  const drawer = document.querySelector('facets-drawer');
  if (!drawer) return;
  e.preventDefault();
  drawer.open();
});

// Auto-submit sort form
document.addEventListener('change', (e) => {
  const sortForm = e.target.closest('[data-sort-form]');
  if (!sortForm) return;
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', sortForm.querySelector('select').value);
  window.location.href = url.toString();
});
